import type { DeleteDepartmentTypesMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

const mapTrpcResponseToGraphQL = (
  affectedRows: number
): DeleteDepartmentTypesMutation => {
  return {
    deleteDepartmentTypeApi: {
      __typename: 'GenericMutationOutput',
      affected_rows: affectedRows,
    },
  };
};

export const useDeleteDepartmentTypesTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.department.delete.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.department.allTypes.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.department.departmentTypeById.queryKey(),
        });
      },
    }),
  });

  return {
    deleteDepartmentTypes: async (variables: {
      Ids: string[];
    }): Promise<DeleteDepartmentTypesMutation> => {
      const result = await mutation.mutateAsync({ Ids: variables.Ids });

      return mapTrpcResponseToGraphQL(result.affected_rows);
    },
    loading: mutation.isPending,
    error: mutation.error,
    data: mutation.data
      ? mapTrpcResponseToGraphQL(mutation.data.affected_rows)
      : undefined,
  };
};
